/**
 * SpatialReader
 *
 * Combines a spatial layer with an IndexedPngDB to read
 * png-db records in a spatial context.
 */

import { dist } from './core/utils';


export default class SpatialReader {

    constructor(db, shader, config) {
        this.config = config;
        this.db = db;
        this.shader = shader;
        this.filter = config.filter;

        this.size = {
            width: config.marker.radius * 4,
            height: config.marker.radius * 2,
        };

        const canvas = document.createElement('canvas');
        canvas.setAttribute('width', this.size.width);
        canvas.setAttribute('height', this.size.height);

        this.context = canvas.getContext('2d');
    }


    /**
     * @return Array<Object>
     */
    readSpace(latLng) {

        //tileRects come from up to 4 tiles depending on what the mouse circle covers
        const { mouseRect, tileRects } = this.shader.tileLayer.getTileRects(latLng, this.size.height);

        this.context.clearRect(0, 0, this.size.width, this.size.height);
        tileRects.forEach((r, i) => {
            if (r.textureImages) {
                r.textureImages.forEach((img, i) => {
                    const x = (this.size.height / 2) - r.center.x;
                    const y = (this.size.height / 2) - r.center.y;
                    //the same image is used for start and stop indices. First draw the starts...
                    this.context.drawImage(img, r.rect.x, r.rect.y, r.rect.width, r.rect.height, x, y, r.rect.width, r.rect.height);
                    //... then grab the "stops" using an offset of 256
                    this.context.drawImage(img, 256 + r.rect.x, r.rect.y, r.rect.width, r.rect.height, x + (this.size.width / 2), y, r.rect.width, r.rect.height);
                });
            }
        });

        const startStops = {};
        const pix = this.context.getImageData(0, 0, this.size.width, this.size.height).data;
        for (let i = 0; i < pix.length; i += 4) {
            var a = pix[i + 3];

            if (a > 0) {
                var x = (i / 4) % this.size.width;
                var y = Math.floor((i / 4) / this.size.width);

                var id = `${x}_${y}`;
                var t = 'start';
                if (x >= 50) {
                    id = `${x - 50}_${y}`;
                    t = 'stop';
                }
                if (!(id in startStops)) {
                    startStops[id] = {};
                }

                startStops[id][t] = {r: pix[i], g: pix[i + 1], b: pix[i + 2]};
            }
        }

        let records = [];
        Object.keys(startStops).forEach((k) => {
            var ss = startStops[k];
            if (!ss.start || !ss.stop) {
                return;
            }

            this.db.addRecordsByIndexColor(records, ss.start, ss.stop);
        });
        records = records.filter(r => !!r);

        return {
            filtered: records.filter(r => this.filter(r, this.shader.props)),
            unfiltered: records,
        };
    }

}
